import reqwest from 'reqwest';

export default (context, next) => {
  let {api, request, response, rawReq} = context;

  reqwest({
    url              : api.uri,
    type             : rawReq.type,
    method           : rawReq.method,
    contentType      : rawReq.contentType,
    headers          : rawReq.headers,
    data             : rawReq.data,
    crossOrigin      : rawReq.crossOrigin,
    withCredentials  : rawReq.withCredentials,
    jsonpCallback    : rawReq.jsonpCallback,
    jsonpCallbackName: rawReq.jsonpCallbackName,
    success(result) {
      context.rawRes = result;
      response.body = result;
      next();
    },
    error(error) {
      context.rawRes = error;
      context.error = error;
      next();
    }
  });
};



// WEBPACK FOOTER //
// ./src/middlewares/reqwest.js